module.exports = __webpack_public_path__ + "img/1517848430.3195be8a.jpg";